import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import CssBaseline from '@mui/material/CssBaseline';
import store from 'src/store';
import theme from 'src/theme';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from 'src/store/store';
import { UserManager, WebStorageStateStore } from 'oidc-react';
import AuthTemplate from 'src/entities/auth/AuthTemplate';
import { oidcConfig } from 'src/entities/auth/config';
import AlertsProvider from './AlertsProvider';

type Props = {
  children: ReactNode;
};

export const userManager = new UserManager({
  authority: oidcConfig.authority as string,
  client_id: oidcConfig.clientId as string,
  client_secret: oidcConfig.clientSecret,
  redirect_uri: oidcConfig.redirectUri as string,
  silent_redirect_uri: oidcConfig.redirectUri as string,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

function AppProviders({ children }: Props) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AlertsProvider>
            <AuthTemplate>
              <BrowserRouter>{children}</BrowserRouter>
            </AuthTemplate>
          </AlertsProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default AppProviders;
